import { useMemo, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import CreateEventSteps from './CreateEventSteps';
import { Dialog } from '@mui/material';
import NextBackButtonGroup from './NextBackButtonGroup';
import useUser from '@hooks/useUser';
import useStripeAccount from '@hooks/useStripeAccount';
import { EventForm, getDefaultNewEvent, newEventSchema } from './CreateEventUtils';
import useModalControl from '@hooks/useModalControl';

interface Props {
    onClose: () => void;
    showModal: boolean;
}

// NOTE: I've copied and distributed the code from the legacy event editing drawer
// feel free to refactor this off of antd!
export default function CreateEventModal({ onClose, showModal }: Props) {
    // TODO: prevent user from navigating away from the page if they have unsaved changes
    const { showEventModal } = useModalControl();
    const { user } = useUser();
    const [currentStep, setCurrentStep] = useState(0);
    const onNextClick = () => {
        setCurrentStep(currentStep + 1);
    };
    const { stripeInfo } = useStripeAccount();
    const defaultValues: Partial<EventForm> = useMemo(
        () =>
            getDefaultNewEvent(
                typeof showEventModal === 'object' ? showEventModal : undefined,
                stripeInfo?.detailsSubmitted,
                user?.id,
            ),
        [showEventModal, stripeInfo?.detailsSubmitted, user?.id],
    );
    const formMethods = useForm<EventForm>({
        defaultValues,
        mode: 'all',
        resolver: yupResolver(newEventSchema),
    });

    // onPrevClick decrements the page by 1 unless we are already at page 0
    const onPrevClick = () => {
        const prevPage = Math.max(0, currentStep - 1);
        setCurrentStep(prevPage);
    };

    return (
        <FormProvider {...formMethods}>
            <form>
                <Dialog fullWidth maxWidth="lg" sx={{ height: '90%' }} open={showModal}>
                    <CreateEventSteps step={currentStep} />
                    <NextBackButtonGroup
                        step={currentStep}
                        onClose={onClose}
                        onPrevClick={onPrevClick}
                        onNextClick={onNextClick}
                    />
                </Dialog>
            </form>
        </FormProvider>
    );
}
